import { render, staticRenderFns } from "./dragForm.vue?vue&type=template&id=37af24e0&"
import script from "./dragForm.vue?vue&type=script&lang=js&"
export * from "./dragForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports